<template>
  <div class="panel-body text-size-20 font-bold flex">
    <div class="panel-content">
      サービスの変更に伴い、ヤマト運輸倉庫への直接納品は廃止となりました。
      <br>
      ヤマト運輸倉庫へ納品したい場合は、以下の手順で実施してください。
      <br>
      <ol>
        <li>ACROSS倉庫画面を開く</li>
        <li>「直接納品」メニューからACROSS倉庫へ納品</li>
        <li>商品の納品後、「ヤマト運輸倉庫へ出荷」メニューから出荷依頼登録</li>
      </ol>
    </div>
  </div>
</template>

<script>
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'delivery-request-registration') {
      let logParams = {
        name: eventCode.delivery_requests.delivery_request_registration_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>
<style scoped>
  .panel-body {
    padding: 40px;
  }
  .panel-content {
    display: inline-block;
    min-width: max-content;
  }
  ol {
    padding-inline-start: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/view/deliveryRequests/DeliveryRequestRegistration.vue